<template>
  <div class="event-wrapper" :class="{'seated-event' : event.event_type == 1}">
    <div class="event-header-wrapper">
      <event-card :event="event" always-show-description :showBuyTicketsBtn="false"></event-card>
    </div>

    <!-- 1 - Seats / 2 - GA -->
    <template v-if="event.event_type == 1">
      <Seated :event="event"></Seated>
    </template>
    <template v-if="event.event_type == 2">
      <GA :event="event"></GA>
    </template>
    <template v-if="event.event_type == 3">
      <SeatsIo :event="event"></SeatsIo>
    </template>
  </div>
</template>
<style scoped lang="scss">
  .event-title {
    color: #3F51B5 !important;
    font-weight: bold;
  }
  .event-details {
    color: #3F51B5;
  }
  .event-icon {
    color: #3F51B5 !important;
    font-size: 15px;
  }

  .event-wrapper {
    max-width: 800px;
    margin: 0 auto;

    &.seated-event {
      max-width: 1200px;
    }
  }

  .event-header-wrapper {
    max-width: 800px;
    margin: 0 auto;
  }
</style>
<script>
  import Seated from './Event/Seated'
  import GA from './Event/GeneralAdmission'
  import SeatsIo from './Event/SeatsIo'
  import EventCard from "./EventCard"

  import {useEvent} from "../stores/event";

  export default {
    title() {
      return 'Articket Tickets | ' + this.event.name
    },
    components: {
      Seated,
      GA,
      EventCard,
      SeatsIo
    },
    props: {
      event: {
        type: Object,
        require: true
      }
    },
    setup() {
      const activeEvent = useEvent()

      return {
        activeEvent
      }
    },
    computed: {
      id() {
        return this.event.id;
      },
    },
    data() {
      return {
        applySameName: false,
        header: this.$route.query.h
      }
    },
    mounted() {
      this.$set(this.activeEvent, 'data', this.event)
    }
  }
</script>
